<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Confirmar Envío a Comisión</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>

      <section class="modal-card-body">
        <p class="mb-3">
          Se ha enviado un código de verificación a su correo
          <strong>{{ email }}</strong
          >.
        </p>

        <p class="mb-4">
          Ingrese el código para confirmar la {{ rol === 'DIRECTOR DEPTO' ? 'aceptación' : 'emisión' }} del compromiso de desempeño.
        </p>

        <b-field label="Código de Verificación">
          <b-input
            v-model="code"
            placeholder="Código de 6 caracteres"
            maxlength="6"
            type="text"
            expanded
          />
        </b-field>

        <b-button
          @click="reenviarCodigo"
          type="is-text"
          class="mt-3"
          :disabled="cooldown > 0"
        >
          {{ cooldown > 0 ? `Reenviar en ${cooldown}s` : "Reenviar código" }}
        </b-button>
      </section>

      <footer class="modal-card-foot actions">
        <div class="actions">
          <button class="button" type="button" @click="$emit('close')">
            Cancelar
          </button>
          <b-button
            type="is-success"
            icon-left="check"
            @click="validarCodigo"
            :disabled="!code || code.length !== 6"
            :loading="isLoading"
          >
            Verificar y Firmar
          </b-button>
        </div>
      </footer>
    </div>
    <b-loading v-model="isLoading" is-full-page />
  </section>
</template>

<script>
import axios from "axios";
export default {
  props: {
    email: {
      type: String,
    },
    personId: {
      type: Number,
    },
    performanceId: {
      type: Number,
    },
    rol: {
      type: String,
    },
  },
  data() {
    return {
      code: "",
      error: "",
      cooldown: 0,
      intervalId: null,
      cooldownSeconds: 60,
      isLoading: false,
    };
  },
  mounted() {
    const savedTime = localStorage.getItem("cooldownStart");
    if (savedTime) {
      const elapsed = Math.floor((Date.now() - parseInt(savedTime)) / 1000);
      const remaining = this.cooldownSeconds - elapsed;
      if (remaining > 0) {
        this.cooldown = remaining;
        this.startCooldownTimer();
      } else {
        localStorage.removeItem("cooldownStart");
      }
    }
  },
  methods: {
    // Dispara validación
    async validarCodigo() {
      if (!this.code || this.code.length !== 6) {
        this.$buefy.toast.open({
          message: 'Debe ingresar un código válido de 6 caracteres',
          type: 'is-warning',
          duration: 3000
        });
        return;
      }

      this.error = "";
      this.isLoading = true;
      axios
        .post("/verification_codes/validate.json", {
          email: this.email,
          code: this.code,
          performance_id: this.performanceId,
          rol: this.rol,
        })
        .then((response) => {
          let message =
            "El código fue validado y su compromiso fue emitido correctamente.";
          if (this.rol === "DIRECTOR DEPTO") {
            message =
              "El código fue validado y el compromiso fue aceptado correctamente.";
          }
          this.$buefy.toast.open({
            message: message,
            type: "is-success",
            duration: 3000,
            position: "is-bottom"
          });
          
          this.isLoading = false;
          this.$emit("close");
          
          // Recargar la página después de un tiempo prudencial para que se complete la transacción
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        })
        .catch((error) => {
          console.log(error);
          let message =
            "Hubo un error al validar el código. Inténtelo nuevamente.";
          if (error.response?.data?.error) {
            message = error.response.data.error;
          }
          this.$buefy.toast.open({
            message: message,
            type: "is-danger",
            duration: 5000,
            position: "is-bottom"
          });
          this.isLoading = false;
        });
    },

    // Reenvío con temporizador de 1 minuto
    async reenviarCodigo() {
      this.isLoading = true;
      axios
        .post("/verification_codes.json", {
          email: this.email,
          reenvio: true,
        })
        .then((res) => {
          this.$buefy.dialog.alert({
            title: "Código Reenviado",
            message: "Se ha enviado un nuevo código a su correo electrónico.",
            type: "is-success",
            hasIcon: true,
            icon: "check-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.cooldown = this.cooldownSeconds;
          localStorage.setItem("cooldownStart", Date.now().toString());
          this.startCooldownTimer();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al reenviar el código.",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.isLoading = false;
        });
    },
    startCooldownTimer() {
      if (this.intervalId) clearInterval(this.intervalId);

      this.intervalId = setInterval(() => {
        if (this.cooldown > 0) {
          this.cooldown--;
        } else {
          clearInterval(this.intervalId);
          this.intervalId = null;
          localStorage.removeItem("cooldownStart");
        }
      }, 1000);
    },
    beforeDestroy() {
      // Limpia el intervalo si el componente se destruye
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  width: 100%;
}
</style>
